<template>
  <div>
    <flat-pickr v-model="localValue" :config="config"></flat-pickr>
  </div>
</template>

<script>
  import FlatPickr from 'vue-flatpickr-component';
  import 'flatpickr/dist/flatpickr.css';
  import weekSelect from 'flatpickr/dist/plugins/weekSelect/weekSelect'
  import customMixin from '@/mixins/customMixin'
  export default {
    name:'Vbdatapicker',
    props:{
      value: {
        type: String, 
			}
    },
     mixins : [customMixin],
    components: {
      FlatPickr
    },
    data: function(){
      return{
        localValue: this.value,
        config: {
          weekNumbers:false,
          dateFormat: 'Y-m-d', //Y-m-d este cambio afecta todo los que usan este componente 
          wrap: true,
          locale: { 
            firstDayOfWeek: 1,
            weekdays: {
              shorthand: this.shortHandDia(),
              longhand: this.longHandDia(),         
            }, 
            months: {
              shorthand:  this.shortHandMes(),
              longhand: this.longHandMes(),
            },
            weekAbbreviation: "Sm",
          },//locale
         
         
                  
        },   //config
        
      }//return
    },
    mounted(){
      //
    },
    watch:{
			localValue (newValue) {
		    this.$emit('input', newValue)
			},
			value (newValue) {
       	this.localValue = newValue
     	}
		},
    methods:{
      //
    }
    
        
  }
</script>

<style lang="scss" scoped>

</style>